import { SidePanelModal } from './SidePanelModal';
import React from 'react';
import { SidePanelsState } from '../state/SidePanelsState';

export interface WixPatternsPanelModalsContainerProps {
  state: SidePanelsState;
}

export function WixPatternsPanelModalsContainer(
  props: WixPatternsPanelModalsContainerProps,
) {
  const { state } = props;

  return <SidePanelModal state={state} top={0} />;
}
